'use client';

import { useEffect, useRef } from 'react';

import { usePathname } from 'next/navigation';

import { recordLanding } from '@naumu/analytics/attribution/touch-storage';

/**
 * Records marketing attribution on every landing.
 *
 * Runs on mount and on every pathname change. Only the mount pass (a real
 * document load - every ad click is one) feeds `document.referrer` in; see
 * `recordLanding` for why soft navigations must not.
 *
 * Writes are skipped when the landing carries no attribution signal and a live
 * record already exists, so ordinary in-app navigation costs one URL parse.
 *
 * twin-of: apps/web/src/lib/attribution/touch-attribution-provider.tsx -
 * `usePathname` is router-coupled, which `@naumu/analytics` bans, so each app
 * owns this thin wrapper and shares the storage logic underneath.
 */
export const TouchAttributionProvider = () => {
	const pathname = usePathname();
	const isDocumentLoadRef = useRef(true);

	useEffect(() => {
		const includeReferrer = isDocumentLoadRef.current;
		isDocumentLoadRef.current = false;
		recordLanding({ includeReferrer });
	}, [pathname]);

	return null;
};
